import React, { createContext, useMemo, useState } from 'react';

const defaultContext = {
  estimatedAmountFinanced: 0,
  isError: false,
  isLoaded: false,
  isLoading: false,
  setEstimatedAmountFinanced: (_: number) => {},
  setError: (_: boolean) => {},
  setLoading: (_: boolean) => {},
  setIsLoaded: (_: boolean) => {},
  setTriggerUserFinancingRequest: (_: number) => {},
  triggerUserFinancingRequest: 0
};

const FinanceContext = createContext(defaultContext);

export type ContextType = typeof defaultContext;

export function FinanceContextProvider({ children }: React.PropsWithChildren) {
  const [estimatedAmountFinanced, setEstimatedAmountFinanced] = useState(
    defaultContext.estimatedAmountFinanced
  );
  const [isError, setError] = useState(defaultContext.isError);
  const [isLoading, setLoading] = useState(defaultContext.isLoading);
  const [isLoaded, setIsLoaded] = useState(defaultContext.isLoading);

  const [triggerUserFinancingRequest, setTriggerUserFinancingRequest] =
    useState(0);

  const value = useMemo<ContextType>(
    () => ({
      estimatedAmountFinanced,
      isError,
      isLoaded,
      isLoading,
      setEstimatedAmountFinanced,
      setError,
      setIsLoaded,
      setLoading,
      setTriggerUserFinancingRequest,
      triggerUserFinancingRequest
    }),
    [
      estimatedAmountFinanced,
      isError,
      isLoaded,
      isLoading,
      triggerUserFinancingRequest
    ]
  );

  return (
    <FinanceContext.Provider value={value}>{children}</FinanceContext.Provider>
  );
}

FinanceContextProvider.displayName = 'FinanceContextProvider';

export default FinanceContext;
